import React from 'react'
import CaptchaV1 from "./CaptchaV1";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";
import RecaptchaV3 from "../RecaptchaV3";

function Captcha({onChange, type = "v1"}) {
	console.log({hostname: window.location.hostname, type})
	if (type === "YESUAT" || type === "YESBNK" || type==='YES-PROD' || window.location.hostname ===  "user.yespayleaf.in" || window.location.hostname ===  "corporate.yesleap.in" || window.location.hostname ===  "user.yesleap.in") {
		return (<CaptchaV1 onChange={onChange}/>)
	}
	return (
		<GoogleReCaptchaProvider reCaptchaKey="6LdONk0kAAAAAM3aVQuxbR76xPD6w4NLr35Ir8eF">
			<RecaptchaV3 onToken={token=>{
				onChange(token!==undefined)
			}}/>
		</GoogleReCaptchaProvider>
	)
}

export default Captcha;
export {Captcha}
